const page = {
  ja: {
    CSS: {
      'css-flexbox': {
        formal: 'CSS Flexbox',
        description: 'FlexboxとはFlexible Box Layout Moduleのことで、柔軟なレイアウトを簡単に実現することができるCSS3の新しいレイアウトモジュールです。\n要素の横並びにfloatやinline-blockを使用するのは時代遅れです。\nFlexboxのプロパティをチートシートにまとめてみました。',
        books: [
          {
            name: 'HTML5／CSS3モダンコーディング　フロントエンドエンジニアが教える3つの本格レイアウト　スタンダード・グリッド・シングルページレイアウトの作り方',
            url: 'https://rpx.a8.net/svt/ejp?a8mat=35HMAT+FCIA5U+2HOM+BWGDT&rakuten=y&a8ejpredirect=http%3A%2F%2Fhb.afl.rakuten.co.jp%2Fhgc%2Fg00rd1d4.2bo114c4.g00rd1d4.2bo126fd%2Fa19061840832_35HMAT_FCIA5U_2HOM_BWGDT%3Fpc%3Dhttp%253A%252F%252Fitem.rakuten.co.jp%252Fbooxstore%252Fbk-4798141577%252F%26m%3Dhttp%253A%252F%252Fm.rakuten.co.jp%252Fbooxstore%252Fi%252F11626915%252F'
          },
          {
            name: 'スラスラわかるHTML＆CSSのきほん　サンプル実習',
            url: 'https://rpx.a8.net/svt/ejp?a8mat=35HMAT+FCIA5U+2HOM+BWGDT&rakuten=y&a8ejpredirect=http%3A%2F%2Fhb.afl.rakuten.co.jp%2Fhgc%2Fg00rd1d4.2bo114c4.g00rd1d4.2bo126fd%2Fa19061840832_35HMAT_FCIA5U_2HOM_BWGDT%3Fpc%3Dhttp%253A%252F%252Fitem.rakuten.co.jp%252Fbooxstore%252Fbk-4797393157%252F%26m%3Dhttp%253A%252F%252Fm.rakuten.co.jp%252Fbooxstore%252Fi%252F12143334%252F'
          },
          {
            name: '作りながら学ぶHTML/CSSデザインの教科書',
            url: 'https://rpx.a8.net/svt/ejp?a8mat=35HMAT+FCIA5U+2HOM+BWGDT&rakuten=y&a8ejpredirect=http%3A%2F%2Fhb.afl.rakuten.co.jp%2Fhgc%2Fg00r00z4.2bo116db.g00r00z4.2bo128ff%2Fa19061840832_35HMAT_FCIA5U_2HOM_BWGDT%3Fpc%3Dhttp%253A%252F%252Fitem.rakuten.co.jp%252Fdorama%252Fn33025090%252F%26m%3Dhttp%253A%252F%252Fm.rakuten.co.jp%252Fdorama%252Fi%252F11233795%252F'
          }
        ],
      },
      sass: {
        formal: 'Sass',
        description: 'SassとはSyntactically Awesome Stylesheetsのことで、CSSをより構造的に記述することのできるCSSのメタ言語です。SASS記法とSCSS記法の二種類が存在します。\n変数、四則演算、if文やwhile文が使えるため、リーダブルでメンテナブルに記述することができ、開発効率が向上します。\nそんな便利なSass(SCSS記法)をチートシートにまとめました。',
        links: [
          {
            name: '【公式】Sass',
            url: 'https://sass-lang.com/'
          }
        ],
        books: [
          {
            name: 'Web制作者のためのSassの教科書　Webデザインの現場で必須のCSSプリプロセッサ',
            url: 'https://rpx.a8.net/svt/ejp?a8mat=35HMAT+FCIA5U+2HOM+BWGDT&rakuten=y&a8ejpredirect=http%3A%2F%2Fhb.afl.rakuten.co.jp%2Fhgc%2Fg00r00z4.2bo116db.g00r00z4.2bo128ff%2Fa19061840832_35HMAT_FCIA5U_2HOM_BWGDT%3Fpc%3Dhttp%253A%252F%252Fitem.rakuten.co.jp%252Fdorama%252Fn33657585%252F%26m%3Dhttp%253A%252F%252Fm.rakuten.co.jp%252Fdorama%252Fi%252F13163331%252F'
          },
          {
            name: 'Web制作者のためのCSS設計の教科書 モダンWeb開発に欠かせない「修正しやすいCSS」',
            url: 'https://rpx.a8.net/svt/ejp?a8mat=35HMAT+FCIA5U+2HOM+BWGDT&rakuten=y&a8ejpredirect=http%3A%2F%2Fhb.afl.rakuten.co.jp%2Fhgc%2Fg00q0724.2bo11c45.g00q0724.2bo12179%2Fa19061840832_35HMAT_FCIA5U_2HOM_BWGDT%3Fpc%3Dhttp%253A%252F%252Fitem.rakuten.co.jp%252Fbook%252F12845305%252F%26m%3Dhttp%253A%252F%252Fm.rakuten.co.jp%252Fbook%252Fi%252F17020894%252F'
          },
          {
            name: 'HTML5／CSS3モダンコーディング　フロントエンドエンジニアが教える3つの本格レイアウト　スタンダード・グリッド・シングルページレイアウトの作り方',
            url: 'https://rpx.a8.net/svt/ejp?a8mat=35HMAT+FCIA5U+2HOM+BWGDT&rakuten=y&a8ejpredirect=http%3A%2F%2Fhb.afl.rakuten.co.jp%2Fhgc%2Fg00rd1d4.2bo114c4.g00rd1d4.2bo126fd%2Fa19061840832_35HMAT_FCIA5U_2HOM_BWGDT%3Fpc%3Dhttp%253A%252F%252Fitem.rakuten.co.jp%252Fbooxstore%252Fbk-4798141577%252F%26m%3Dhttp%253A%252F%252Fm.rakuten.co.jp%252Fbooxstore%252Fi%252F11626915%252F'
          },
        ],
      },
      'css-selector': {
        formal: 'CSS セレクタ',
        description: '【図解付き】知っておくと便利なCSSのセレクタの種類と使用例を図解付きでチートシートにまとめました。\n隣接セレクタやbefore/afterといった疑似要素、何番目の要素かを指定するnth-childやhoverなどのよく使用する疑似クラスを表現する方法をまとめてみました。',
        books: [
          {
            name: 'Web制作者のためのCSS設計の教科書 モダンWeb開発に欠かせない「修正しやすいCSS」',
            url: 'https://rpx.a8.net/svt/ejp?a8mat=35HMAT+FCIA5U+2HOM+BWGDT&rakuten=y&a8ejpredirect=http%3A%2F%2Fhb.afl.rakuten.co.jp%2Fhgc%2Fg00q0724.2bo11c45.g00q0724.2bo12179%2Fa19061840832_35HMAT_FCIA5U_2HOM_BWGDT%3Fpc%3Dhttp%253A%252F%252Fitem.rakuten.co.jp%252Fbook%252F12845305%252F%26m%3Dhttp%253A%252F%252Fm.rakuten.co.jp%252Fbook%252Fi%252F17020894%252F'
          },
          {
            name: 'HTML5／CSS3モダンコーディング　フロントエンドエンジニアが教える3つの本格レイアウト　スタンダード・グリッド・シングルページレイアウトの作り方',
            url: 'https://rpx.a8.net/svt/ejp?a8mat=35HMAT+FCIA5U+2HOM+BWGDT&rakuten=y&a8ejpredirect=http%3A%2F%2Fhb.afl.rakuten.co.jp%2Fhgc%2Fg00rd1d4.2bo114c4.g00rd1d4.2bo126fd%2Fa19061840832_35HMAT_FCIA5U_2HOM_BWGDT%3Fpc%3Dhttp%253A%252F%252Fitem.rakuten.co.jp%252Fbooxstore%252Fbk-4798141577%252F%26m%3Dhttp%253A%252F%252Fm.rakuten.co.jp%252Fbooxstore%252Fi%252F11626915%252F'
          },
          {
            name: 'フロントエンドエンジニアのための現在とこれからの必須知識',
            url: 'https://rpx.a8.net/svt/ejp?a8mat=35HMAT+FCIA5U+2HOM+BWGDT&rakuten=y&a8ejpredirect=http%3A%2F%2Fhb.afl.rakuten.co.jp%2Fhgc%2Fg00r00z4.2bo116db.g00r00z4.2bo128ff%2Fa19061840832_35HMAT_FCIA5U_2HOM_BWGDT%3Fpc%3Dhttp%253A%252F%252Fitem.rakuten.co.jp%252Fdorama%252Fn33393513%252F%26m%3Dhttp%253A%252F%252Fm.rakuten.co.jp%252Fdorama%252Fi%252F12232429%252F'
          },
        ]
      },
      'css-cursor': {
        formal: 'CSS cursorプロパティ',
        description: '【図解付き】cursor: pointer以外にも、moveやgrabなどの知っておくと便利なcursorプロパティをチートシートにまとめてみました。',
        links: [
          {
            name: 'CSS cursor プロパティ | MDN web docs',
            url: 'https://developer.mozilla.org/ja/docs/Web/CSS/cursor'
          }
        ],
        books: [
          {
            name: 'HTML5／CSS3モダンコーディング　フロントエンドエンジニアが教える3つの本格レイアウト　スタンダード・グリッド・シングルページレイアウトの作り方',
            url: 'https://rpx.a8.net/svt/ejp?a8mat=35HMAT+FCIA5U+2HOM+BWGDT&rakuten=y&a8ejpredirect=http%3A%2F%2Fhb.afl.rakuten.co.jp%2Fhgc%2Fg00rd1d4.2bo114c4.g00rd1d4.2bo126fd%2Fa19061840832_35HMAT_FCIA5U_2HOM_BWGDT%3Fpc%3Dhttp%253A%252F%252Fitem.rakuten.co.jp%252Fbooxstore%252Fbk-4798141577%252F%26m%3Dhttp%253A%252F%252Fm.rakuten.co.jp%252Fbooxstore%252Fi%252F11626915%252F'
          },
          {
            name: 'スラスラわかるHTML＆CSSのきほん　サンプル実習',
            url: 'https://rpx.a8.net/svt/ejp?a8mat=35HMAT+FCIA5U+2HOM+BWGDT&rakuten=y&a8ejpredirect=http%3A%2F%2Fhb.afl.rakuten.co.jp%2Fhgc%2Fg00rd1d4.2bo114c4.g00rd1d4.2bo126fd%2Fa19061840832_35HMAT_FCIA5U_2HOM_BWGDT%3Fpc%3Dhttp%253A%252F%252Fitem.rakuten.co.jp%252Fbooxstore%252Fbk-4797393157%252F%26m%3Dhttp%253A%252F%252Fm.rakuten.co.jp%252Fbooxstore%252Fi%252F12143334%252F'
          },
          {
            name: '作りながら学ぶHTML/CSSデザインの教科書',
            url: 'https://rpx.a8.net/svt/ejp?a8mat=35HMAT+FCIA5U+2HOM+BWGDT&rakuten=y&a8ejpredirect=http%3A%2F%2Fhb.afl.rakuten.co.jp%2Fhgc%2Fg00r00z4.2bo116db.g00r00z4.2bo128ff%2Fa19061840832_35HMAT_FCIA5U_2HOM_BWGDT%3Fpc%3Dhttp%253A%252F%252Fitem.rakuten.co.jp%252Fdorama%252Fn33025090%252F%26m%3Dhttp%253A%252F%252Fm.rakuten.co.jp%252Fdorama%252Fi%252F11233795%252F'
          }
        ],
      }
    },
    マークアップ: {
      markdown: {
        formal: 'マークダウン記法',
        description: 'マークダウンとは手軽に文章構造を明示できる軽量マークアップ言語のひとつです。プレーンテキストとして記述した文書をHTML形式に変換することができます。\nそんな便利なマークダウン記法をチートシートにまとめてみました。',
        books: [
          {
            name: 'はじめてのMarkdown 軽量マークアップ言語の記法と使い方',
            url: 'https://rpx.a8.net/svt/ejp?a8mat=35HMAT+FCIA5U+2HOM+BWGDT&rakuten=y&a8ejpredirect=http%3A%2F%2Fhb.afl.rakuten.co.jp%2Fhgc%2Fg00q0724.2bo11c45.g00q0724.2bo12179%2Fa19061840832_35HMAT_FCIA5U_2HOM_BWGDT%3Fpc%3Dhttp%253A%252F%252Fitem.rakuten.co.jp%252Fbook%252F12773787%252F%26m%3Dhttp%253A%252F%252Fm.rakuten.co.jp%252Fbook%252Fi%252F16935349%252F'
          },
          {
            name: 'Markdownライティング入門 プレーンテキストで気楽に書こう！',
            url: 'https://rpx.a8.net/svt/ejp?a8mat=35HMAT+FCIA5U+2HOM+BWGDT&rakuten=y&a8ejpredirect=http%3A%2F%2Fhb.afl.rakuten.co.jp%2Fhgc%2Fg00q0724.2bo11c45.g00q0724.2bo12179%2Fa19061840832_35HMAT_FCIA5U_2HOM_BWGDT%3Fpc%3Dhttp%253A%252F%252Fitem.rakuten.co.jp%252Fbook%252F15736848%252F%26m%3Dhttp%253A%252F%252Fm.rakuten.co.jp%252Fbook%252Fi%252F19435751%252F'
          }
        ]
      },
      yaml: {
        formal: 'YAML',
        description: 'YAMLは再帰的に定義された頭字語であり、"YAML Ain\'t a Markup Language"(YAMLはマークアップ言語ではない)の意味である。類似の規格としてはJSONが挙げられる。\n設定ファイルでよく使用されるYAMLについてまとめてみました。'
      }
    },
    JavaScript: {
      'jquery-to-vanillajs': {
        formal: 'jQuery -> Vanilla JSの変換',
        description: 'Vanilla JSとは純粋なJavaScriptのことです。Pure JSと呼ばれたりもします。jQueryなどのライブラリありきでJavaScriptを考える風潮に皮肉を込めてVanilla JSと呼ばれています。\nReact.jsやVue.jsが台頭してくる中でjQueryに依存しない純粋なJavaScriptの書き方を覚えるために、jQuery -> Vanilla JSの対応関係をチートシートにまとめてみました。',
        links: [
          {
            name: '【公式】Vanilla JS',
            url: 'http://vanilla-js.com/'
          }
        ],
        books: [
          {
            name: 'JavaScript 第6版',
            url: 'https://rpx.a8.net/svt/ejp?a8mat=35HMAT+FCIA5U+2HOM+BWGDT&rakuten=y&a8ejpredirect=http%3A%2F%2Fhb.afl.rakuten.co.jp%2Fhgc%2Fg00rakq4.2bo11a85.g00rakq4.2bo12fb9%2Fa19061840832_35HMAT_FCIA5U_2HOM_BWGDT%3Fpc%3Dhttp%253A%252F%252Fitem.rakuten.co.jp%252Fvaboo%252Fsvug190619-0368%252F%26m%3Dhttp%253A%252F%252Fm.rakuten.co.jp%252Fvaboo%252Fi%252F16956073%252F'
          },
          {
            name: 'JavaScript本格入門　モダンスタイルによる基礎から現場での応用まで',
            url: 'https://rpx.a8.net/svt/ejp?a8mat=35HMAT+FCIA5U+2HOM+BWGDT&rakuten=y&a8ejpredirect=http%3A%2F%2Fhb.afl.rakuten.co.jp%2Fhgc%2Fg00rd1d4.2bo114c4.g00rd1d4.2bo126fd%2Fa19061840832_35HMAT_FCIA5U_2HOM_BWGDT%3Fpc%3Dhttp%253A%252F%252Fitem.rakuten.co.jp%252Fbooxstore%252Fbk-477418411x%252F%26m%3Dhttp%253A%252F%252Fm.rakuten.co.jp%252Fbooxstore%252Fi%252F11830149%252F'
          },
          {
            name: 'JavaScriptコードレシピ集　スグに使えるテクニック278',
            url: 'https://rpx.a8.net/svt/ejp?a8mat=35HMAT+FCIA5U+2HOM+BWGDT&rakuten=y&a8ejpredirect=http%3A%2F%2Fhb.afl.rakuten.co.jp%2Fhgc%2Fg00r00z4.2bo116db.g00r00z4.2bo128ff%2Fa19061840832_35HMAT_FCIA5U_2HOM_BWGDT%3Fpc%3Dhttp%253A%252F%252Fitem.rakuten.co.jp%252Fdorama%252Fn33873675%252F%26m%3Dhttp%253A%252F%252Fm.rakuten.co.jp%252Fdorama%252Fi%252F13888693%252F',
          }
        ]
      },
      react: {
        formal: 'React',
        description: 'Reactは、Facebookとそのコミュニティによって開発されているユーザインタフェースを構築するためのJavaScriptライブラリです。React.jsまたはReactJSの名称としても知られています',
        links: [
          {
            name: '【公式】React – ユーザインターフェース構築のための JavaScript ライブラリ ',
            url: 'https://ja.reactjs.org/',
          },
          {
            name: 'facebook/react - GitHub',
            url: 'https://github.com/facebook/react',
          },
        ],
      },
    },
    Ruby: {
      rspec: {
        formal: 'RSpec',
        description: 'RSpecとはRubyで実装されたBDD(behavior driven development)のためのテスティングフレームワークです。自然言語のような読み書きのしやすさが特徴です。\nRSpecの基本的な書き方、テストコードのDRY化のための仕組み、マッチャなどをチートシートにまとめてみました。',
        links: [
          {
            name: '【公式】http://rspec.info/',
            url: 'http://rspec.info/'
          },
          {
            name: 'rspec/rspec - GitHub',
            url: 'https://github.com/rspec/rspec'
          },
          {
            name: 'rspec/rspec-rails',
            url: 'https://github.com/rspec/rspec-rails'
          },
        ],
        books: [
          {
            name: 'The RSpec Book',
            url: 'https://rpx.a8.net/svt/ejp?a8mat=35HMAT+FCIA5U+2HOM+BWGDT&rakuten=y&a8ejpredirect=http%3A%2F%2Fhb.afl.rakuten.co.jp%2Fhgc%2Fg00r00z4.2bo116db.g00r00z4.2bo128ff%2Fa19061840832_35HMAT_FCIA5U_2HOM_BWGDT%3Fpc%3Dhttp%253A%252F%252Fitem.rakuten.co.jp%252Fdorama%252Fn32714983%252F%26m%3Dhttp%253A%252F%252Fm.rakuten.co.jp%252Fdorama%252Fi%252F11254793%252F'
          },
          {
            name: 'テスト駆動開発',
            url: 'https://rpx.a8.net/svt/ejp?a8mat=35HMAT+FCIA5U+2HOM+BWGDT&rakuten=y&a8ejpredirect=http%3A%2F%2Fhb.afl.rakuten.co.jp%2Fhgc%2Fg00r00z4.2bo116db.g00r00z4.2bo128ff%2Fa19061840832_35HMAT_FCIA5U_2HOM_BWGDT%3Fpc%3Dhttp%253A%252F%252Fitem.rakuten.co.jp%252Fdorama%252Fn33672174%252F%26m%3Dhttp%253A%252F%252Fm.rakuten.co.jp%252Fdorama%252Fi%252F13195422%252F'
          },
          {
            name: 'プロを目指す人のためのRuby入門　言語仕様からテスト駆動開発・デバッグ技法まで',
            url: 'https://rpx.a8.net/svt/ejp?a8mat=35HMAT+FCIA5U+2HOM+BWGDT&rakuten=y&a8ejpredirect=http%3A%2F%2Fhb.afl.rakuten.co.jp%2Fhgc%2Fg00rd1d4.2bo114c4.g00rd1d4.2bo126fd%2Fa19061840832_35HMAT_FCIA5U_2HOM_BWGDT%3Fpc%3Dhttp%253A%252F%252Fitem.rakuten.co.jp%252Fbooxstore%252Fbk-4774193976%252F%26m%3Dhttp%253A%252F%252Fm.rakuten.co.jp%252Fbooxstore%252Fi%252F12053272%252F'
          },
          {
            name: 'メタプログラミングRuby',
            url: 'https://rpx.a8.net/svt/ejp?a8mat=35HMAT+FCIA5U+2HOM+BWGDT&rakuten=y&a8ejpredirect=http%3A%2F%2Fhb.afl.rakuten.co.jp%2Fhgc%2Fg00rd1d4.2bo114c4.g00rd1d4.2bo126fd%2Fa19061840832_35HMAT_FCIA5U_2HOM_BWGDT%3Fpc%3Dhttp%253A%252F%252Fitem.rakuten.co.jp%252Fbooxstore%252Fbk-4873117437%252F%26m%3Dhttp%253A%252F%252Fm.rakuten.co.jp%252Fbooxstore%252Fi%252F11612495%252F'
          }
        ]
      }
    },
    DesignPattern: {
      design_pattern: {
        formal: 'デザインパターン',
        description: 'デザインパターンとは、ソフトウェアを開発・設計する際に、「よく出会う問題とそれに対処する設計とを23パターンに分類したもの」です。デザインパターンを習得することで、再利用性が高く、リーダブルなコードを開発することができます。また、開発者間でのコミュニケーションにおける共通言語としても利用することができます。',
        books: [],
      },
      template_method: {
        formal: 'テンプレートメソッドパターン',
        description: 'TemplateMethod（テンプレートメソッド）パターンとは、「一部のアルゴリズムを変更する」デザインパターンです。不変なものと可変はものを分離することで、拡張性が高く、メンテナブルなコードを書くことができます。',
        books: [],
      },
      strategy: {
        formal: 'ストラテジーパターン',
        description: 'Strategy（ストラテジー）パターンとは、「アルゴリズムを交換する」デザインパターンです。戦略（Strategy）を独立したクラスで定義し、それをコンテキストに渡すことで、実行時に柔軟性を保った状態でロジックを移譲することができます。',
        books: [],
      },
      observer: {
        formal: 'オブザーバーパターン',
        description: 'Observer（オブザーバー）パターンとは、「変更を通知する」デザインパターンです。SubjectとObserverという役割を分けることで、イベントを発生を伝えるインタフェースをきれいにすることができます。そうすることで、必要以上にクラスを結合することなく、各クラスが各々の責務となっているロジックに集中することができ、高凝集・低結合を保つことができます。',
        books: [],
      },
      composite: {
        formal: 'コンポジットパターン',
        description: 'Composite（コンポジット）パターンとは、「容器と中身を同一視する」デザインパターンです。階層構造、ツリー構造などの再帰的なデータを扱う際に、コードの重複を排除し、拡張性が高く柔軟なコードを書くことができます。',
        books: [],
      },
      chain_of_responsibility: {
        formal: 'チェーンオブレスポンシビリティパターン',
        description: 'Chain of Responsibility（チェーンオブレスポンシビリティ）パターンとは、「責任を連鎖させる」デザインパターンです。Clientの課題を解決する責任を持つHandlerに対して、nextのHandlerを定義して鎖状にHandlerをつなげることで、柔軟な実装を可能とするデザインパターンです。',
        books: [],
      },
    },
    DevOps: {
      docker: {
        formal: 'Docker',
        description: 'Dockerとはコンテナと呼ばれるOSレベルの仮想化環境を提供するソフトウェアです。近年、コンテナ化したアプリケーションのデプロイ、スケーリング、管理を行うためのコンテナオーケストレーションシステムであるKubernetesの採用事例も増え、ますますコンテナ仮想化技術は注目されています。\nDockerコマンドをチートシートにまとめました。',
        links: [
          {
            name: '【公式】Docker Documentation（英語）',
            url: 'https://docs.docker.com/'
          },
          {
            name: 'Docker ドキュメント日本語化プロジェクト',
            url: 'http://docs.docker.jp/'
          },
        ],
        books: [
          {
            name: 'Docker',
            url: 'https://rpx.a8.net/svt/ejp?a8mat=35HMAT+FCIA5U+2HOM+BWGDT&rakuten=y&a8ejpredirect=http%3A%2F%2Fhb.afl.rakuten.co.jp%2Fhgc%2Fg00r00z4.2bo116db.g00r00z4.2bo128ff%2Fa19061840832_35HMAT_FCIA5U_2HOM_BWGDT%3Fpc%3Dhttp%253A%252F%252Fitem.rakuten.co.jp%252Fdorama%252Fn33484065%252F%26m%3Dhttp%253A%252F%252Fm.rakuten.co.jp%252Fdorama%252Fi%252F12559269%252F'
          },
          {
            name: 'プログラマのためのDocker教科書　インフラの基礎知識＆コードによる環境構築の自動化',
            url: 'https://rpx.a8.net/svt/ejp?a8mat=35HMAT+FCIA5U+2HOM+BWGDT&rakuten=y&a8ejpredirect=http%3A%2F%2Fhb.afl.rakuten.co.jp%2Fhgc%2Fg00rd1d4.2bo114c4.g00rd1d4.2bo126fd%2Fa19061840832_35HMAT_FCIA5U_2HOM_BWGDT%3Fpc%3Dhttp%253A%252F%252Fitem.rakuten.co.jp%252Fbooxstore%252Fbk-4798153222%252F%26m%3Dhttp%253A%252F%252Fm.rakuten.co.jp%252Fbooxstore%252Fi%252F12141104%252F'
          },
          {
            name: 'みんなのDocker/Kubernetes',
            url: 'https://rpx.a8.net/svt/ejp?a8mat=35HMAT+FCIA5U+2HOM+BWGDT&rakuten=y&a8ejpredirect=http%3A%2F%2Fhb.afl.rakuten.co.jp%2Fhgc%2Fg00r00z4.2bo116db.g00r00z4.2bo128ff%2Fa19061840832_35HMAT_FCIA5U_2HOM_BWGDT%3Fpc%3Dhttp%253A%252F%252Fitem.rakuten.co.jp%252Fdorama%252Fn33912491%252F%26m%3Dhttp%253A%252F%252Fm.rakuten.co.jp%252Fdorama%252Fi%252F13983314%252F'
          },
        ]
      },
      gcp: {
        formal: 'GCP(Google Cloud Platform)',
        description: 'Google Cloud Platform(GCP)とは、Googleが提供しているクラウドコンピューティングサービスです。Google検索やYouTubeなどのサービスでも利用されています。GCPが提供するCLIツールのコマンドをチートシートにまとめてみました。',
        links: [
          {
            name: '【公式】Google Cloud Platform スタートガイド',
            url: 'https://cloud.google.com/getting-started/?hl=ja'
          },
        ],
        books: [
          {
            name: 'GCPの教科書',
            url: 'https://rpx.a8.net/svt/ejp?a8mat=35HMAT+FCIA5U+2HOM+BWGDT&rakuten=y&a8ejpredirect=http%3A%2F%2Fhb.afl.rakuten.co.jp%2Fhgc%2Fg00r00z4.2bo116db.g00r00z4.2bo128ff%2Fa19061840832_35HMAT_FCIA5U_2HOM_BWGDT%3Fpc%3Dhttp%253A%252F%252Fitem.rakuten.co.jp%252Fdorama%252Fn33910432%252F%26m%3Dhttp%253A%252F%252Fm.rakuten.co.jp%252Fdorama%252Fi%252F13981109%252F'
          },
          {
            name: 'プログラマのためのGoogle Cloud Platform入門 サービスの全体像からクラウドネイティブアプリケーション構築まで',
            url: 'https://rpx.a8.net/svt/ejp?a8mat=35HMAT+FCIA5U+2HOM+BWGDT&rakuten=y&a8ejpredirect=http%3A%2F%2Fhb.afl.rakuten.co.jp%2Fhgc%2Fg00r00z4.2bo116db.g00r00z4.2bo128ff%2Fa19061840832_35HMAT_FCIA5U_2HOM_BWGDT%3Fpc%3Dhttp%253A%252F%252Fitem.rakuten.co.jp%252Fdorama%252Fn33612820%252F%26m%3Dhttp%253A%252F%252Fm.rakuten.co.jp%252Fdorama%252Fi%252F12964763%252F'
          },
        ]
      },
    },
    CLI: {
      git: {
        formal: 'Git',
        description: 'Gitとはソースコードの変更履歴を記録・追跡するための分散型バージョン管理システムです。過去のファイルの状態に戻したり、チームで変更履歴を共有して効率良くチーム開発を行うことができます。\nそんな便利なGitをチートシートにまとめてみました。',
        books: [
          {
            name: 'わかばちゃんと学ぶGit使い方入門',
            url: 'https://rpx.a8.net/svt/ejp?a8mat=35HMAT+FCIA5U+2HOM+BWGDT&rakuten=y&a8ejpredirect=http%3A%2F%2Fhb.afl.rakuten.co.jp%2Fhgc%2Fg00r00z4.2bo116db.g00r00z4.2bo128ff%2Fa19061840832_35HMAT_FCIA5U_2HOM_BWGDT%3Fpc%3Dhttp%253A%252F%252Fitem.rakuten.co.jp%252Fdorama%252Fn33597144%252F%26m%3Dhttp%253A%252F%252Fm.rakuten.co.jp%252Fdorama%252Fi%252F12942955%252F'
          },
          {
            name: 'サルでもわかるGit入門',
            url: 'https://rpx.a8.net/svt/ejp?a8mat=35HMAT+FCIA5U+2HOM+BWGDT&rakuten=y&a8ejpredirect=http%3A%2F%2Fhb.afl.rakuten.co.jp%2Fhgc%2Fg00r00z4.2bo116db.g00r00z4.2bo128ff%2Fa19061840832_35HMAT_FCIA5U_2HOM_BWGDT%3Fpc%3Dhttp%253A%252F%252Fitem.rakuten.co.jp%252Fdorama%252Fn33820320%252F%26m%3Dhttp%253A%252F%252Fm.rakuten.co.jp%252Fdorama%252Fi%252F13824792%252F'
          },
          {
            name: '入門git',
            url: 'https://rpx.a8.net/svt/ejp?a8mat=35HMAT+FCIA5U+2HOM+BWGDT&rakuten=y&a8ejpredirect=http%3A%2F%2Fhb.afl.rakuten.co.jp%2Fhgc%2Fg00r00z4.2bo116db.g00r00z4.2bo128ff%2Fa19061840832_35HMAT_FCIA5U_2HOM_BWGDT%3Fpc%3Dhttp%253A%252F%252Fitem.rakuten.co.jp%252Fdorama%252Fn32292789%252F%26m%3Dhttp%253A%252F%252Fm.rakuten.co.jp%252Fdorama%252Fi%252F10954545%252F'
          },
        ]
      }
    },
    "Management/Strategy": {
      management_marketing: {
        formal: '経営/マーケティング用語',
        description: 'プロダクト開発、新規事業の立ち上げからグロース、マーケティングなど、組織内で共通言語として意味を理解しておいた方が良いものをチートシートにまとめてみました。',
        books: [
          {
            name: '起業の科学 スタートアップサイエンス',
            url: 'https://rpx.a8.net/svt/ejp?a8mat=35HMAT+FCIA5U+2HOM+BWGDT&rakuten=y&a8ejpredirect=http%3A%2F%2Fhb.afl.rakuten.co.jp%2Fhgc%2Fg00r00z4.2bo116db.g00r00z4.2bo128ff%2Fa19061840832_35HMAT_FCIA5U_2HOM_BWGDT%3Fpc%3Dhttp%253A%252F%252Fitem.rakuten.co.jp%252Fdorama%252Fn33680480%252F%26m%3Dhttp%253A%252F%252Fm.rakuten.co.jp%252Fdorama%252Fi%252F13228592%252F'
          },
          {
            name: 'リーン・スタートアップ ムダのない起業プロセスでイノベーションを生みだす',
            url: 'https://rpx.a8.net/svt/ejp?a8mat=35HMAT+FCIA5U+2HOM+BWGDT&rakuten=y&a8ejpredirect=http%3A%2F%2Fhb.afl.rakuten.co.jp%2Fhgc%2Fg00r00z4.2bo116db.g00r00z4.2bo128ff%2Fa19061840832_35HMAT_FCIA5U_2HOM_BWGDT%3Fpc%3Dhttp%253A%252F%252Fitem.rakuten.co.jp%252Fdorama%252Fn32742705%252F%26m%3Dhttp%253A%252F%252Fm.rakuten.co.jp%252Fdorama%252Fi%252F11094196%252F'
          },
          {
            name: '実践顧客起点マーケティング　たった一人の分析から事業は成長する',
            url: 'https://rpx.a8.net/svt/ejp?a8mat=35HMAT+FCIA5U+2HOM+BWGDT&rakuten=y&a8ejpredirect=http%3A%2F%2Fhb.afl.rakuten.co.jp%2Fhgc%2Fg00rk0p4.2bo11af8.g00rk0p4.2bo12494%2Fa19061840832_35HMAT_FCIA5U_2HOM_BWGDT%3Fpc%3Dhttp%253A%252F%252Fitem.rakuten.co.jp%252Fbookfan%252Fbk-4798160075%252F%26m%3Dhttp%253A%252F%252Fm.rakuten.co.jp%252Fbookfan%252Fi%252F12061914%252F'
          }
        ]
      },
      xaas: {
        formal: 'XaaS("X" as a Service)',
        description: 'SaaSやPaaSといったクラウドサービスに使われる「aaS(as a Service)」という用語の一覧をチートシートにまとめてみました。',
        links: [
          {
            name: 'IaaS PaaS SaaSの違い｜クラウドエース（Cloud Ace）',
            url: 'https://www.cloud-ace.jp/report/detail01/',
          },
          {
            name: 'Baas, Caas, Daas, Iaas, Maas, Paas, Saas, Faasについてのまとめ | Qiita',
            url: 'https://qiita.com/cocoa-maemae/items/6d9b6edc3082a678ed0f',
          },
        ],
        books: [
          {
            name: '起業の科学 スタートアップサイエンス',
            url: 'https://rpx.a8.net/svt/ejp?a8mat=35HMAT+FCIA5U+2HOM+BWGDT&rakuten=y&a8ejpredirect=http%3A%2F%2Fhb.afl.rakuten.co.jp%2Fhgc%2Fg00r00z4.2bo116db.g00r00z4.2bo128ff%2Fa19061840832_35HMAT_FCIA5U_2HOM_BWGDT%3Fpc%3Dhttp%253A%252F%252Fitem.rakuten.co.jp%252Fdorama%252Fn33680480%252F%26m%3Dhttp%253A%252F%252Fm.rakuten.co.jp%252Fdorama%252Fi%252F13228592%252F'
          },
          {
            name: 'ビジネスモデル2.0図鑑',
            url: 'https://rpx.a8.net/svt/ejp?a8mat=35HMAT+FCIA5U+2HOM+BWGDT&rakuten=y&a8ejpredirect=http%3A%2F%2Fhb.afl.rakuten.co.jp%2Fhgc%2Fg00qtaz4.2bo11387.g00qtaz4.2bo1245a%2Fa19061840832_35HMAT_FCIA5U_2HOM_BWGDT%3Fpc%3Dhttp%253A%252F%252Fitem.rakuten.co.jp%252Fhmvjapan%252F9092582%252F%26m%3Dhttp%253A%252F%252Fm.rakuten.co.jp%252Fhmvjapan%252Fi%252F17362935%252F'
          },
          {
            name: '実践顧客起点マーケティング　たった一人の分析から事業は成長する',
            url: 'https://rpx.a8.net/svt/ejp?a8mat=35HMAT+FCIA5U+2HOM+BWGDT&rakuten=y&a8ejpredirect=http%3A%2F%2Fhb.afl.rakuten.co.jp%2Fhgc%2Fg00rk0p4.2bo11af8.g00rk0p4.2bo12494%2Fa19061840832_35HMAT_FCIA5U_2HOM_BWGDT%3Fpc%3Dhttp%253A%252F%252Fitem.rakuten.co.jp%252Fbookfan%252Fbk-4798160075%252F%26m%3Dhttp%253A%252F%252Fm.rakuten.co.jp%252Fbookfan%252Fi%252F12061914%252F'
          }
        ]
      },
    },
  },
  /*=== ENGLISH ===*/
  en: {
    CSS: {
      'css-flexbox': {
        formal: 'CSS Flexbox',
        description: 'Flexbox(Flexible Box Layout Module) is a CSS3 web layout model. The flex layout allows responsive elements within a container to be automatically arranged depending upon screen size (or device).\nThe float and inline-block is outdated.\nThis is cheatsheet page about Flexbox.',
        books: [
          {
            name: 'Responsive Web Design with HTML5 and CSS3 Essentials',
            url: 'https://rpx.a8.net/svt/ejp?a8mat=35HMAT+FCIA5U+2HOM+BWGDT&rakuten=y&a8ejpredirect=http%3A%2F%2Fhb.afl.rakuten.co.jp%2Fhgc%2Fg00reb44.2bo11755.g00reb44.2bo12ad3%2Fa19061840832_35HMAT_FCIA5U_2HOM_BWGDT%3Fpc%3Dhttp%253A%252F%252Fitem.rakuten.co.jp%252Frakutenkobo-ebooks%252F494aea753b2531ca9401aedef6f30ea4%252F%26m%3Dhttp%253A%252F%252Fm.rakuten.co.jp%252Frakutenkobo-ebooks%252Fi%252F15783076%252F'
          },
          {
            name: 'Responsive Web Design with HTML5 and CSS3',
            url: 'https://rpx.a8.net/svt/ejp?a8mat=35HMAT+FCIA5U+2HOM+BWGDT&rakuten=y&a8ejpredirect=http%3A%2F%2Fhb.afl.rakuten.co.jp%2Fhgc%2Fg00reb44.2bo11755.g00reb44.2bo12ad3%2Fa19061840832_35HMAT_FCIA5U_2HOM_BWGDT%3Fpc%3Dhttp%253A%252F%252Fitem.rakuten.co.jp%252Frakutenkobo-ebooks%252F48923a7131694658a91be645fe17a4c5%252F%26m%3Dhttp%253A%252F%252Fm.rakuten.co.jp%252Frakutenkobo-ebooks%252Fi%252F12205118%252F'
          },
        ]
      },
      sass: {
        formal: 'Sass',
        description: 'Sass(Syntactically Awesome Stylesheets) is a CSS meta language for making CSS structure better. There are two notations, SASS and SCSS.\nReadable and maintenable because you can use variables, four arithmetic operations, if and while statement, so Sass boost your development.\nThis is cheatsheet page about Sass.',
        links: [
          {
            name: 'official - Sass',
            url: 'https://sass-lang.com/'
          }
        ],
        books: [
          {
            name: 'Mastering Sass',
            url: 'https://rpx.a8.net/svt/ejp?a8mat=35HMAT+FCIA5U+2HOM+BWGDT&rakuten=y&a8ejpredirect=http%3A%2F%2Fhb.afl.rakuten.co.jp%2Fhgc%2Fg00reb44.2bo11755.g00reb44.2bo12ad3%2Fa19061840832_35HMAT_FCIA5U_2HOM_BWGDT%3Fpc%3Dhttp%253A%252F%252Fitem.rakuten.co.jp%252Frakutenkobo-ebooks%252F80356927c248363ab44b05104ba69ddb%252F%26m%3Dhttp%253A%252F%252Fm.rakuten.co.jp%252Frakutenkobo-ebooks%252Fi%252F15629848%252F'
          },
          {
            name: 'Jump Start SassGet Up to Speed With Sass in a Weekend',
            url: 'https://rpx.a8.net/svt/ejp?a8mat=35HMAT+FCIA5U+2HOM+BWGDT&rakuten=y&a8ejpredirect=http%3A%2F%2Fhb.afl.rakuten.co.jp%2Fhgc%2Fg00reb44.2bo11755.g00reb44.2bo12ad3%2Fa19061840832_35HMAT_FCIA5U_2HOM_BWGDT%3Fpc%3Dhttp%253A%252F%252Fitem.rakuten.co.jp%252Frakutenkobo-ebooks%252Fe4cb5054adb33b879b8f1d41b5983d1e%252F%26m%3Dhttp%253A%252F%252Fm.rakuten.co.jp%252Frakutenkobo-ebooks%252Fi%252F15440956%252F'
          },
        ]
      },
      'css-selector': {
        formal: 'CSS Selector',
        description: '[With illustration] This is cheatsheet page about useful css selector.\nThere are adjacent sibling combinator, pseudo-elements(before, after, ...) and pseudo-class(nth-child, hover, ...).',
        books: [
          {
            name: 'Responsive Web Design with HTML5 and CSS3 Essentials',
            url: 'https://rpx.a8.net/svt/ejp?a8mat=35HMAT+FCIA5U+2HOM+BWGDT&rakuten=y&a8ejpredirect=http%3A%2F%2Fhb.afl.rakuten.co.jp%2Fhgc%2Fg00reb44.2bo11755.g00reb44.2bo12ad3%2Fa19061840832_35HMAT_FCIA5U_2HOM_BWGDT%3Fpc%3Dhttp%253A%252F%252Fitem.rakuten.co.jp%252Frakutenkobo-ebooks%252F494aea753b2531ca9401aedef6f30ea4%252F%26m%3Dhttp%253A%252F%252Fm.rakuten.co.jp%252Frakutenkobo-ebooks%252Fi%252F15783076%252F'
          },
          {
            name: 'Responsive Web Design with HTML5 and CSS3',
            url: 'https://rpx.a8.net/svt/ejp?a8mat=35HMAT+FCIA5U+2HOM+BWGDT&rakuten=y&a8ejpredirect=http%3A%2F%2Fhb.afl.rakuten.co.jp%2Fhgc%2Fg00reb44.2bo11755.g00reb44.2bo12ad3%2Fa19061840832_35HMAT_FCIA5U_2HOM_BWGDT%3Fpc%3Dhttp%253A%252F%252Fitem.rakuten.co.jp%252Frakutenkobo-ebooks%252F48923a7131694658a91be645fe17a4c5%252F%26m%3Dhttp%253A%252F%252Fm.rakuten.co.jp%252Frakutenkobo-ebooks%252Fi%252F12205118%252F'
          },
        ]
      },
      'css-cursor': {
        formal: 'CSS cursor property',
        description: 'Illustrated - In addition to cursor: pointer, we have put together cursor properties that are useful to know such as move and grab in a cheat sheet.',
        links: [
          {
            name: 'cursor | MDN web docs',
            url: 'https://developer.mozilla.org/en-US/docs/Web/CSS/cursor'
          }
        ],
        books: [
          {
            name: 'Responsive Web Design with HTML5 and CSS3 Essentials',
            url: 'https://rpx.a8.net/svt/ejp?a8mat=35HMAT+FCIA5U+2HOM+BWGDT&rakuten=y&a8ejpredirect=http%3A%2F%2Fhb.afl.rakuten.co.jp%2Fhgc%2Fg00reb44.2bo11755.g00reb44.2bo12ad3%2Fa19061840832_35HMAT_FCIA5U_2HOM_BWGDT%3Fpc%3Dhttp%253A%252F%252Fitem.rakuten.co.jp%252Frakutenkobo-ebooks%252F494aea753b2531ca9401aedef6f30ea4%252F%26m%3Dhttp%253A%252F%252Fm.rakuten.co.jp%252Frakutenkobo-ebooks%252Fi%252F15783076%252F'
          },
          {
            name: 'Responsive Web Design with HTML5 and CSS3',
            url: 'https://rpx.a8.net/svt/ejp?a8mat=35HMAT+FCIA5U+2HOM+BWGDT&rakuten=y&a8ejpredirect=http%3A%2F%2Fhb.afl.rakuten.co.jp%2Fhgc%2Fg00reb44.2bo11755.g00reb44.2bo12ad3%2Fa19061840832_35HMAT_FCIA5U_2HOM_BWGDT%3Fpc%3Dhttp%253A%252F%252Fitem.rakuten.co.jp%252Frakutenkobo-ebooks%252F48923a7131694658a91be645fe17a4c5%252F%26m%3Dhttp%253A%252F%252Fm.rakuten.co.jp%252Frakutenkobo-ebooks%252Fi%252F12205118%252F'
          },
        ],
      }
    },
    Markup: {
      markdown: {
        formal: 'Markdown',
        description: 'Markdown is a lightweight markup language with plain text formatting syntax.\nIts design allows it to be converted to many output formats, but the original tool by the same name only supports HTML.\nThis is cheatsheet page about markdown.',
        books: [
          {
            name: 'Markdown und PandocSyntax. Werkzeuge. LaTeX und HTML.',
            url: 'https://rpx.a8.net/svt/ejp?a8mat=35HMAT+FCIA5U+2HOM+BWGDT&rakuten=y&a8ejpredirect=http%3A%2F%2Fhb.afl.rakuten.co.jp%2Fhgc%2Fg00reb44.2bo11755.g00reb44.2bo12ad3%2Fa19061840832_35HMAT_FCIA5U_2HOM_BWGDT%3Fpc%3Dhttp%253A%252F%252Fitem.rakuten.co.jp%252Frakutenkobo-ebooks%252F15b64c485c333bd2885fdedb74409577%252F%26m%3Dhttp%253A%252F%252Fm.rakuten.co.jp%252Frakutenkobo-ebooks%252Fi%252F17887728%252F'
          },
          {
            name: 'Instant Markdown',
            url: 'https://rpx.a8.net/svt/ejp?a8mat=35HMAT+FCIA5U+2HOM+BWGDT&rakuten=y&a8ejpredirect=http%3A%2F%2Fhb.afl.rakuten.co.jp%2Fhgc%2Fg00reb44.2bo11755.g00reb44.2bo12ad3%2Fa19061840832_35HMAT_FCIA5U_2HOM_BWGDT%3Fpc%3Dhttp%253A%252F%252Fitem.rakuten.co.jp%252Frakutenkobo-ebooks%252F5f54a81e7e053640bbaa9ac95a24dbe1%252F%26m%3Dhttp%253A%252F%252Fm.rakuten.co.jp%252Frakutenkobo-ebooks%252Fi%252F13992786%252F'
          },
        ]
      },
      yaml: {
        formal: 'YAML',
        description: 'YAML ("YAML Ain\'t Markup Language") is a human-readable data-serialization language. It is commonly used for configuration files, but could be used in many applications where data is being stored or transmitted.\nThis is cheatsheet page about yaml.',
      }
    },
    JavaScript: {
      'jquery-to-vanillajs': {
        formal: 'jQuery -> Vanilla JS',
        description: 'According to the official view, Vanilla JS is a fast, lightweight, cross-platform framework for building incredible, powerful JavaScript applications. Vanilla JS means pure JavaScript without any frameworks or libraries.\nThis is cheatsheet page about converting jQuery to Vanilla JS.',
        links: [
          {
            name: 'official - Vanilla JS',
            url: 'http://vanilla-js.com/'
          }
        ],
        books: [
          {
            name: 'A Smarter Way to Learn JavaScript: The New Approach That Uses Technology to Cut Your Effort in Half',
            url: 'https://rpx.a8.net/svt/ejp?a8mat=35HMAT+FCIA5U+2HOM+BWGDT&rakuten=y&a8ejpredirect=http%3A%2F%2Fhb.afl.rakuten.co.jp%2Fhgc%2Fg00t3y14.2bo11433.g00t3y14.2bo127ff%2Fa19061840832_35HMAT_FCIA5U_2HOM_BWGDT%3Fpc%3Dhttp%253A%252F%252Fitem.rakuten.co.jp%252Fbookriver%252F9781497408180_144807%252F%26m%3Dhttp%253A%252F%252Fm.rakuten.co.jp%252Fbookriver%252Fi%252F10127833%252F'
          },
          {
            name: 'Eloquent JavaScript, 3rd EditionA Modern Introduction to Programming',
            url: 'https://rpx.a8.net/svt/ejp?a8mat=35HMAT+FCIA5U+2HOM+BWGDT&rakuten=y&a8ejpredirect=http%3A%2F%2Fhb.afl.rakuten.co.jp%2Fhgc%2Fg00reb44.2bo11755.g00reb44.2bo12ad3%2Fa19061840832_35HMAT_FCIA5U_2HOM_BWGDT%3Fpc%3Dhttp%253A%252F%252Fitem.rakuten.co.jp%252Frakutenkobo-ebooks%252F72cd0aa24e1b3495ae371689fa0c3d30%252F%26m%3Dhttp%253A%252F%252Fm.rakuten.co.jp%252Frakutenkobo-ebooks%252Fi%252F17274084%252F'
          },
        ]
      },
      react: {
        formal: 'React',
        description: 'React is a JavaScript library for building user interfaces developed by Facebook and the community. Also known as React.js or ReactJS.',
        links: [
          {
            name: 'Official - React A JavaScript library for building user interfacesReact',
            url: 'https://reactjs.org/',
          },
          {
            name: 'facebook/react - GitHub',
            url: 'https://github.com/facebook/react',
          },
        ],
      },
    },
    Ruby: {
      rspec: {
        formal: 'RSpec',
        description: "RSpec is a behavior-driven development(BDD) testing framework which is written in Ruby to test Ruby code. RSpec's feature is writability and readability like a natural language.\nThis is cheatsheet page about RSpec fundamental writing way, how to DRY test code and useful matcher.",
        links: [
          {
            name: 'official - http://rspec.info/',
            url: 'http://rspec.info/'
          },
          {
            name: 'rspec/rspec - GitHub',
            url: 'https://github.com/rspec/rspec'
          },
          {
            name: 'rspec/rspec-rails',
            url: 'https://github.com/rspec/rspec-rails'
          }
        ],
        books: [
          {
            name: 'Effective Testing with Rspec 3: Build Ruby Apps with Confidence',
            url: 'https://rpx.a8.net/svt/ejp?a8mat=35HMAT+FCIA5U+2HOM+BWGDT&rakuten=y&a8ejpredirect=http%3A%2F%2Fhb.afl.rakuten.co.jp%2Fhgc%2Fg00suyv4.2bo119fd.g00suyv4.2bo12bec%2Fa19061840832_35HMAT_FCIA5U_2HOM_BWGDT%3Fpc%3Dhttp%253A%252F%252Fitem.rakuten.co.jp%252Fexcellentimports%252F38-115969545%252F%26m%3Dhttp%253A%252F%252Fm.rakuten.co.jp%252Fexcellentimports%252Fi%252F14473800%252F'
          },
          {
            name: 'The RSpec Book',
            url: 'https://rpx.a8.net/svt/ejp?a8mat=35HMAT+FCIA5U+2HOM+BWGDT&rakuten=y&a8ejpredirect=http%3A%2F%2Fhb.afl.rakuten.co.jp%2Fhgc%2Fg00r00z4.2bo116db.g00r00z4.2bo128ff%2Fa19061840832_35HMAT_FCIA5U_2HOM_BWGDT%3Fpc%3Dhttp%253A%252F%252Fitem.rakuten.co.jp%252Fdorama%252Fn32714983%252F%26m%3Dhttp%253A%252F%252Fm.rakuten.co.jp%252Fdorama%252Fi%252F11254793%252F'
          },
        ]
      }
    },
    DesignPattern: {
      design_pattern: {
        formal: 'DesignPattern',
        description: 'Design patterns are "classified into 23 patterns of frequently encountered problems and designs that deal with them" when developing and designing software. By learning design patterns, you can develop highly reusable and readable code. It can also be used as a common language for communication between developers.',
        books: [],
      },
      template_method: {
        formal: 'TemplateMethod Pattern',
        description: 'The TemplateMethod pattern is a design pattern that "modifies some algorithms." By separating the immutable and the variable, you can write highly extensible and maintainable code.',
        books: [],
      },
      strategy: {
        formal: 'Strategy Pattern',
        description: 'The Strategy pattern is a design pattern that "exchanges algorithms". By defining a Strategy in a separate class and passing it to the context, you can transfer logic with flexibility at run time.',
        books: [],
      },
      observer: {
        formal: 'Observer Pattern',
        description: 'The Observer pattern is a design pattern that "notifies changes". By separating the roles of Subject and Observer, you can clean the interface that conveys the occurrence of an event. By doing so, each class can concentrate on the logic for which it is responsible, without unnecessarily joining classes, and high cohesion and low coupling can be maintained.',
        books: [],
      },
      composite: {
        formal: 'Composite Pattern',
        description: 'The Composite pattern is a design pattern that "identifies the container and the contents". When dealing with recursive data such as hierarchical structures and tree structures, you can eliminate code duplication and write highly extensible and flexible code.',
        books: [],
      },
      chain_of_responsibility: {
        formal: 'Chain of Responsibility Pattern',
        description: 'The Chain of Responsibility pattern is a design pattern that "chains responsibilities". It is a design pattern that enables flexible implementation by defining the next Handler and connecting the Handlers in a chain to the Handler that is responsible for solving the client issues.',
        books: [],
      },
    },
    DevOps: {
      docker: {
        formal: 'Docker',
        description: 'Docker is a set of coupled software-as-a-service and platform-as-a-service products that use operating-system-level virtualization to develop and deliver software in packages called containers. The software that hosts the containers is called Docker Engine.\nThis is cheatsheet page about Docker.',
        links: [
          {
            name: 'official - Docker Documentation',
            url: 'https://docs.docker.com/'
          },
        ],
        books: [
          {
            name: 'Docker in Practice',
            url: 'https://rpx.a8.net/svt/ejp?a8mat=35HMAT+FCIA5U+2HOM+BWGDT&rakuten=y&a8ejpredirect=http%3A%2F%2Fhb.afl.rakuten.co.jp%2Fhgc%2Fg00suyv4.2bo119fd.g00suyv4.2bo12bec%2Fa19061840832_35HMAT_FCIA5U_2HOM_BWGDT%3Fpc%3Dhttp%253A%252F%252Fitem.rakuten.co.jp%252Fexcellentimports%252F38-67155887%252F%26m%3Dhttp%253A%252F%252Fm.rakuten.co.jp%252Fexcellentimports%252Fi%252F14447147%252F'
          },
        ]
      },
      gcp: {
        formal: 'GCP(Google Cloud Platform)',
        description: 'Google Cloud Platform (GCP), offered by Google, is a suite of cloud computing services that runs on the same infrastructure that Google uses internally for its end-user products, such as Google Search and YouTube. This is the cheatsheet page about GCP CLI tools.',
        links: [
          {
            name: 'official - Getting Started with Google Cloud Platform',
            url: 'https://cloud.google.com/getting-started/?hl=en'
          },
        ],
        books: [
          {
            name: 'Practical Java Machine Learning: Projects with Google Cloud Platform and Amazon Web Services',
            url: 'https://rpx.a8.net/svt/ejp?a8mat=35HMAT+FCIA5U+2HOM+BWGDT&rakuten=y&a8ejpredirect=http%3A%2F%2Fhb.afl.rakuten.co.jp%2Fhgc%2Fg00suyv4.2bo119fd.g00suyv4.2bo12bec%2Fa19061840832_35HMAT_FCIA5U_2HOM_BWGDT%3Fpc%3Dhttp%253A%252F%252Fitem.rakuten.co.jp%252Fexcellentimports%252F38-190602958%252F%26m%3Dhttp%253A%252F%252Fm.rakuten.co.jp%252Fexcellentimports%252Fi%252F14336490%252F'
          },
          {
            name: 'Pro DevOps with Google Cloud Platform: With Docker, Jenkins, and Kubernetes',
            url: 'https://rpx.a8.net/svt/ejp?a8mat=35HMAT+FCIA5U+2HOM+BWGDT&rakuten=y&a8ejpredirect=http%3A%2F%2Fhb.afl.rakuten.co.jp%2Fhgc%2Fg00suyv4.2bo119fd.g00suyv4.2bo12bec%2Fa19061840832_35HMAT_FCIA5U_2HOM_BWGDT%3Fpc%3Dhttp%253A%252F%252Fitem.rakuten.co.jp%252Fexcellentimports%252F38-189743174%252F%26m%3Dhttp%253A%252F%252Fm.rakuten.co.jp%252Fexcellentimports%252Fi%252F14338158%252F'
          },
        ]
      },
    },
    CLI: {
      git: {
        formal: 'Git',
        description: 'Git is distributed version-control system for tracking changes in source code during software development. You can revert old version files and develop in a team speedy and flexibly.\nThis is cheatsheet page about Git.',
      }
    },
    "Management/Strategy": {
      management_marketing: {
        formal: 'Management & Marketing',
        description: 'We have put together a cheatsheet for product development, new business start-up, growth, marketing, etc. where it is better to understand the meaning as a common language in an organization.',
        books: [
          {
            name: 'LinkedIn Marketing Workbook and Planner: How to Master Engagement in 15 Minutes a Day',
            url: 'https://rpx.a8.net/svt/ejp?a8mat=35HMAT+FCIA5U+2HOM+BWGDT&rakuten=y&a8ejpredirect=http%3A%2F%2Fhb.afl.rakuten.co.jp%2Fhgc%2Fg00suyv4.2bo119fd.g00suyv4.2bo12bec%2Fa19061840832_35HMAT_FCIA5U_2HOM_BWGDT%3Fpc%3Dhttp%253A%252F%252Fitem.rakuten.co.jp%252Fexcellentimports%252F38-88320055%252F%26m%3Dhttp%253A%252F%252Fm.rakuten.co.jp%252Fexcellentimports%252Fi%252F13292385%252F'
          },
        ]
      },
      xaas: {
        formal: 'XaaS("X" as a Service)',
        description: 'The "XaaS" terms such as SaaS and PaaS is often used for Cloud Service. This is cheatsheet page about XaaS(as a Service).',
        links: [
          {
            name: 'SaaS vs PaaS vs IaaS: What’s The Difference and How To Choose ',
            url: 'SaaS vs PaaS vs IaaS: What’s The Difference and How To Choose ',
          },
          {
            name: '"IaaS vs. PaaS vs. SaaS" Cloud Models',
            url: '"IaaS vs. PaaS vs. SaaS" Cloud Models ',
          },
        ],
        books: [
          {
            name: 'LinkedIn Marketing Workbook and Planner: How to Master Engagement in 15 Minutes a Day',
            url: 'https://rpx.a8.net/svt/ejp?a8mat=35HMAT+FCIA5U+2HOM+BWGDT&rakuten=y&a8ejpredirect=http%3A%2F%2Fhb.afl.rakuten.co.jp%2Fhgc%2Fg00suyv4.2bo119fd.g00suyv4.2bo12bec%2Fa19061840832_35HMAT_FCIA5U_2HOM_BWGDT%3Fpc%3Dhttp%253A%252F%252Fitem.rakuten.co.jp%252Fexcellentimports%252F38-88320055%252F%26m%3Dhttp%253A%252F%252Fm.rakuten.co.jp%252Fexcellentimports%252Fi%252F13292385%252F'
          },
        ]
      }
    }
  }
}
export default page
